// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-editor-shell {
    --content-border: var(--color-border-soft);
    display: grid;
    gap: 1rem;
    min-width: 0;
    width: 100%;
}

/* The dashboard has broad aside/section rules. Keep the editor's nested layout isolated. */
div.page .content-editor-shell aside.content-editor-sidebar {
    align-items: stretch;
    background: transparent;
    display: grid;
    height: auto;
    margin: 0;
    min-width: 0;
    padding: 0;
}

div.page .content-editor-shell section.content-editor-main,
div.page .content-editor-shell section.content-editor-panel {
    background: var(--color-surface);
    border: 1px solid var(--content-border);
    border-radius: 0.4rem;
    display: grid;
    gap: 0.65rem;
    margin: 0;
    max-width: none;
    padding: 1rem;
    position: relative;
}

div.page .content-editor-shell section.content-editor-feature {
    background: transparent;
    border: 0;
    margin: 0;
    max-width: none;
    padding: 0;
    position: static;
}

div.page .content-editor-shell .content-editor-panel h2,
div.page .content-editor-shell .content-editor-panel-header h2 {
    border: 0;
    font-size: 1.1rem;
    margin: 0;
    padding: 0;
}

div.page .content-editor-shell aside.content-editor-sidebar p {
    font-size: 1rem;
    padding: 0;
    text-align: start;
}

.content-list-manager {
    display: grid;
    gap: 1rem;
}

.content-create-form,
.content-link-tree-form {
    align-items: end;
    display: grid;
    gap: 0.5rem;
    grid-template-columns: minmax(12rem, 1fr) auto;
}

.content-create-form label {
    grid-column: 1 / -1;
}

.content-create-form {
    align-items: stretch;
}

.content-create-form > input,
.content-create-form > button {
    min-height: 3.25rem;
}

.content-list-table-wrap {
    overflow-x: auto;
}

.content-list-table-wrap table {
    width: 100%;
}

.content-list-table-wrap small {
    display: block;
}

.content-list-actions,
.content-list-pagination {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.content-list-actions form {
    margin: 0;
}

.content-list-pagination {
    justify-content: space-between;
    margin-top: 1rem;
}

.content-editor-topbar {
    align-items: center;
    background: var(--color-surface);
    border: 1px solid var(--content-border);
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    padding: 0.75rem;
    position: sticky;
    top: 0;
    z-index: 20;
}

.content-editor-heading {
    display: grid;
    flex: 1;
}

.content-editor-heading > span,
.content-editor-heading small {
    color: var(--color-text);
    font-size: 0.82rem;
    opacity: 0.72;
}

.content-editor-topbar-actions,
.content-editor-body-actions,
.content-dialog-actions,
.content-media-actions,
.content-mode-tabs,
.content-editor-toolbar {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.content-editor-layout {
    align-items: start;
    display: grid;
    gap: 1rem;
    grid-template-columns: minmax(0, 2fr) minmax(18rem, 1fr);
    min-width: 0;
}

.content-editor-main,
.content-editor-panel {
    background: var(--color-surface);
    border: 1px solid var(--content-border);
    border-radius: 0.4rem;
    display: grid;
    gap: 0.65rem;
    padding: 1rem;
}

.content-editor-main,
.content-editor-panel,
.content-editor-sidebar,
.content-editor-feature,
.content-editor-feature > [role="tabpanel"] {
    min-width: 0;
}

.content-editor-shell input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]),
.content-editor-shell select,
.content-editor-shell textarea {
    background: var(--color-surface);
    border: 1px solid var(--color-border);
    color: var(--color-text);
    display: block;
    font: inherit;
    max-width: 100%;
    padding: 0.55rem 0.65rem;
    width: 100%;
}

.content-editor-sidebar {
    display: grid;
    gap: 1rem;
}

.content-editor-panel-header {
    align-items: start;
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    justify-content: space-between;
}

.content-editor-panel h2,
.content-editor-panel-header h2 {
    margin: 0;
}

.content-mode-tabs {
    border-bottom: 1px solid var(--content-border);
    margin-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.content-editor-tool-button,
.content-mode-tab {
    appearance: none;
    background: var(--color-surface);
    border: 1px solid var(--content-border);
    border-radius: 0.3rem;
    color: var(--color-text);
    cursor: pointer;
    font: inherit;
    font-size: 0.82rem;
    font-weight: 600;
    line-height: 1.2;
    margin: 0;
    min-height: 2rem;
    padding: 0.4rem 0.65rem;
    white-space: nowrap;
}

.content-editor-tool-button:hover,
.content-mode-tab:hover {
    background: var(--color-hover-bg);
    border-color: var(--color-accent);
}

.content-editor-tool-button:focus-visible,
.content-mode-tab:focus-visible {
    outline: 2px solid var(--color-accent);
    outline-offset: 2px;
}

.content-editor-tool-button[aria-pressed="true"],
.content-mode-tab[aria-selected="true"] {
    background: var(--color-accent);
    border-color: var(--color-accent);
    color: #fff;
}

.content-editor-tool-button:disabled,
.content-mode-tab:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.content-rich-text-editor,
.content-source-editor {
    border: 1px solid var(--content-border);
    border-radius: 0.25rem;
    min-height: 24rem;
    overflow: hidden;
}

.content-editor-toolbar {
    align-items: stretch;
    background: var(--color-surface-soft);
    border-bottom: 1px solid var(--content-border);
    padding: 0.5rem;
}

.content-rich-text-editor-input {
    min-height: 22rem;
    outline: none;
    padding: 1rem;
}

.content-rich-text-editor-input > * {
    max-width: 100%;
}

.content-source-editor .cm-editor {
    max-width: 100%;
    min-height: 24rem;
}

.content-source-editor .cm-scroller {
    overflow: auto;
}

.content-media-list {
    display: grid;
    gap: 0.5rem;
    list-style: none;
    margin: 0;
    padding: 0;
}

.content-media-list li {
    align-items: center;
    border: 1px solid var(--content-border);
    display: grid;
    gap: 0.5rem;
    grid-template-columns: 4rem minmax(0, 1fr) auto;
    padding: 0.5rem;
    min-width: 0;
}

.content-media-list li > * {
    min-width: 0;
}

.content-youtube-list li {
    grid-template-columns: minmax(0, 1fr) auto;
}

.content-youtube-add {
    display: grid;
    gap: 0.5rem;
}

.content-media-list img {
    height: 4rem;
    object-fit: cover;
    width: 4rem;
}

.content-media-list small,
.content-media-list strong {
    display: block;
    overflow-wrap: anywhere;
}

.content-featured-grid {
    display: grid;
    gap: 0.75rem;
    grid-template-columns: repeat(auto-fit, minmax(min(12rem, 100%), 1fr));
}

.content-featured-choice {
    border: 1px solid var(--content-border);
    display: grid;
    gap: 0.5rem;
    padding: 0.75rem;
}

.content-featured-choice h3 {
    margin: 0;
}

.content-featured-choice img {
    aspect-ratio: 16 / 9;
    object-fit: cover;
    width: 100%;
}

.content-masthead-preview {
    aspect-ratio: 16 / 6;
    object-fit: cover;
    width: 100%;
}

.content-editor-content-section {
    border-top: 1px solid var(--content-border);
    display: grid;
    gap: 0.75rem;
    margin-top: 0.5rem;
    padding-top: 1rem;
}

.content-editor-content-heading {
    align-items: start;
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    justify-content: space-between;
}

.content-editor-content-heading h2,
.content-editor-content-heading p {
    margin: 0;
}

.content-segment-toggle {
    display: flex;
    gap: 0.35rem;
}

.content-segment-toggle button {
    appearance: none;
    background: var(--color-surface);
    border: 1px solid var(--content-border);
    border-radius: 999px;
    color: var(--color-text);
    cursor: pointer;
    font: inherit;
    font-size: 0.78rem;
    font-weight: 700;
    padding: 0.35rem 0.65rem;
}

.content-segment-toggle button[aria-selected="true"] {
    background: var(--color-accent);
    border-color: var(--color-accent);
    color: #fff;
}

.content-publication-details {
    display: grid;
    gap: 0.5rem;
    margin: 0;
}

.content-publication-details div {
    display: flex;
    gap: 0.5rem;
    justify-content: space-between;
}

.content-publication-details dt {
    font-weight: 700;
}

.content-publication-details dd {
    margin: 0;
    overflow-wrap: anywhere;
    text-align: end;
}

.content-comment-list {
    display: grid;
    gap: 0.75rem;
    list-style: none;
    margin: 0;
    padding: 0;
}

.content-comment-list > li {
    border: 1px solid var(--content-border);
    display: grid;
    gap: 0.5rem;
    padding: 0.75rem;
}

.content-comment-list header {
    display: flex;
    gap: 0.5rem;
    justify-content: space-between;
}

.content-comment-reply {
    display: grid;
    gap: 0.5rem;
}

.content-inline-alt-dialog {
    background: var(--color-surface);
    border-radius: 0.5rem;
    display: grid;
    gap: 0.75rem;
    margin: 8vh auto;
    max-width: 34rem;
    padding: 1.25rem;
    width: calc(100% - 2rem);
}

.content-conversion-columns {
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.content-conversion-columns pre {
    max-height: 24rem;
    overflow: auto;
    white-space: pre-wrap;
}

.content-preview-frame {
    border: 1px solid var(--content-border);
    height: min(72vh, 900px);
    width: 100%;
}

.content-save-status.is-offline,
.content-save-status.is-invalid,
.content-save-status.is-conflict {
    color: var(--color-danger-text, #9d1c1c);
    font-weight: 700;
}

@media (max-width: 1150px) {
    .content-editor-topbar,
    .content-editor-layout {
        align-items: stretch;
        grid-template-columns: minmax(0, 1fr);
    }

    .content-editor-topbar {
        display: grid;
        position: static;
    }

    .content-conversion-columns {
        grid-template-columns: minmax(0, 1fr);
    }

    .content-featured-grid {
        grid-template-columns: minmax(0, 1fr);
    }

    .content-create-form,
    .content-link-tree-form {
        grid-template-columns: minmax(0, 1fr);
    }

    .content-media-list li {
        grid-template-columns: 3rem minmax(0, 1fr);
    }

    .content-youtube-list li {
        grid-template-columns: minmax(0, 1fr);
    }

    .content-media-actions {
        grid-column: 1 / -1;
    }

}

/* DisplaySettingsSection — design templates + page-takeover mode
   (docs/REACT-PAGE-BLOG-EDITOR.md, 2026-08-21 entry). */
.content-display-mode-toggle {
    display: flex;
    gap: 0.35rem;
}

.content-display-mode-option {
    appearance: none;
    background: var(--color-surface);
    border: 1px solid var(--content-border);
    border-radius: 0.3rem;
    color: var(--color-text);
    cursor: pointer;
    flex: 1;
    font: inherit;
    font-size: 0.78rem;
    font-weight: 600;
    padding: 0.35rem 0.5rem;
}

.content-display-mode-option.selected {
    background: var(--color-accent);
    border-color: var(--color-accent);
    color: #fff;
}

.content-display-template-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
}

.content-display-template-card {
    appearance: none;
    background: var(--color-surface);
    border: 1px solid var(--content-border);
    border-radius: 0.3rem;
    color: var(--color-text);
    cursor: pointer;
    font: inherit;
    font-size: 0.76rem;
    font-weight: 600;
    padding: 0.4rem 0.55rem;
    text-align: center;
}

.content-display-template-card.selected {
    border-color: var(--color-accent);
    box-shadow: 0 0 0 2px var(--color-accent) inset;
}

.content-editor-panel-sub {
    border-top: 1px solid var(--content-border);
    display: grid;
    gap: 0.5rem;
    margin-top: 0.5rem;
    padding-top: 0.5rem;
}

.content-editor-panel-label {
    font-weight: 600;
}

/* Keep writing prominent and disclose configuration below it. */
.content-editor-shell, .content-list-manager {
    max-width: 1100px;
    margin-inline: auto;
}
.content-editor-layout {
    grid-template-columns: minmax(0, 1fr);
}
div.page .content-list-manager > section {
    display: block;
    margin: 0;
    max-width: none;
}
.content-list-manager input[type="text"] {
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
}
.content-editor-main input, .content-editor-main select, .content-editor-main textarea {
    box-sizing: border-box;
}
.content-writing-language {
    display: flex;
    align-items: end;
    gap: 1.5rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid var(--content-border);
    margin-bottom: 0.5rem;
}
.content-writing-language > div {
    flex: 0 0 220px;
}
.content-writing-language label {
    display: block;
    margin-bottom: 0.35rem;
    font-size: 0.875rem;
}
div.page .content-editor-shell .content-writing-language p {
    margin: 0;
    padding: 0.4rem 0;
    text-align: start;
    font-size: 0.875rem;
}
.content-editor-main > label {
    font-weight: 600;
}
.content-editor-main #content-title {
    font-size: 1.25rem;
}
.content-editor-content-section {
    border-top: 0;
    margin-top: 0.75rem;
    padding-top: 0;
}
div.page .content-editor-shell .content-editor-content-heading h2 {
    border: 0;
    margin: 0;
    padding: 0;
    font-size: 1rem;
}
.content-editor-settings {
    display: grid;
    gap: 0;
    border: 1px solid var(--content-border);
    border-radius: 0.4rem;
    background: var(--color-surface);
    overflow: hidden;
}
.content-settings-group + .content-settings-group {
    border-top: 1px solid var(--content-border);
}
.content-settings-group > summary {
    padding: 1rem 1.25rem;
    font-weight: 600;
    cursor: pointer;
    color: var(--color-text);
}
.content-settings-group > summary:hover {
    background: var(--color-hover-bg);
}
.content-settings-group > summary:focus-visible {
    outline: 2px solid var(--color-accent);
    outline-offset: -3px;
}
div.page .content-editor-shell .content-settings-group > section {
    margin: 0 1.25rem 1rem;
    max-width: none;
}
.content-settings-group > p, .content-settings-group > details {
    margin: 1rem 1.25rem;
}
.content-language-note {
    padding: 0.75rem;
    background: var(--color-surface-soft);
    border-radius: 0.25rem;
    font-size: 0.875rem;
}
.content-translation-actions {
    display: flex;
    justify-content: end;
}
.content-text-action {
    appearance: none;
    background: transparent;
    border: 0;
    color: var(--color-link);
    cursor: pointer;
    font: inherit;
    font-size: 0.875rem;
    text-decoration: underline;
    padding: 0.4rem 0;
}
@media (max-width: 650px) {
.content-writing-language {
    display: grid;
    gap: 0.5rem;
}
.content-editor-topbar-actions > .button {
    flex: 1;
    text-align: center;
    padding-inline: 0.75rem;
}
.content-editor-toolbar {
    gap: 0.3rem;
}
.content-editor-tool-button {
    min-height: 2.25rem;
    padding: 0.4rem 0.55rem;
}
}

.content-inline-alt-fields {
    display: grid;
    gap: 1rem;
}
.content-inline-alt-fields > input[type="text"],
.content-inline-alt-fields > input:not([type]) {
    width: 100%;
    box-sizing: border-box;
}

.content-list-manager .content-editor-panel-header {
    display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Content/contentEditor.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,aAAa;IACb,SAAS;IACT,YAAY;IACZ,WAAW;AACf;;AAEA,2FAA2F;AAC3F;IACI,oBAAoB;IACpB,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,UAAU;AACd;;AAEA;;IAEI,gCAAgC;IAChC,uCAAuC;IACvC,qBAAqB;IACrB,aAAa;IACb,YAAY;IACZ,SAAS;IACT,eAAe;IACf,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,SAAS;IACT,eAAe;IACf,UAAU;IACV,gBAAgB;AACpB;;AAEA;;IAEI,SAAS;IACT,iBAAiB;IACjB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;;IAEI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,uCAAuC;IACvC,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,aAAa;IACb,OAAO;AACX;;AAEA;;IAEI,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;;;;;IAMI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,wDAAwD;IACxD,YAAY;AAChB;;AAEA;;IAEI,gCAAgC;IAChC,uCAAuC;IACvC,qBAAqB;IACrB,aAAa;IACb,YAAY;IACZ,aAAa;AACjB;;AAEA;;;;;IAKI,YAAY;AAChB;;AAEA;;;IAGI,gCAAgC;IAChC,qCAAqC;IACrC,wBAAwB;IACxB,cAAc;IACd,aAAa;IACb,eAAe;IACf,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,YAAY;IACZ,8BAA8B;AAClC;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;IAEI,gBAAgB;IAChB,gCAAgC;IAChC,uCAAuC;IACvC,qBAAqB;IACrB,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,iCAAiC;IACjC,iCAAiC;AACrC;;AAEA;;IAEI,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;;IAEI,+BAA+B;IAC/B,iCAAiC;IACjC,WAAW;AACf;;AAEA;;IAEI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;IAEI,uCAAuC;IACvC,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,qCAAqC;IACrC,8CAA8C;IAC9C,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,WAAW;IACX,+CAA+C;IAC/C,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;;IAEI,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,sEAAsE;AAC1E;;AAEA;IACI,uCAAuC;IACvC,aAAa;IACb,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,2CAA2C;IAC3C,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,YAAY;IACZ,8BAA8B;AAClC;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,uCAAuC;IACvC,oBAAoB;IACpB,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,+BAA+B;IAC/B,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,uCAAuC;IACvC,aAAa;IACb,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gDAAgD;AACpD;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,uCAAuC;IACvC,wBAAwB;IACxB,WAAW;AACf;;AAEA;;;IAGI,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA;IACI;;QAEI,oBAAoB;QACpB,qCAAqC;IACzC;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,qCAAqC;IACzC;;IAEA;;QAEI,qCAAqC;IACzC;;IAEA;QACI,0CAA0C;IAC9C;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,mBAAmB;IACvB;;AAEJ;;AAEA;wDACwD;AACxD;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,uCAAuC;IACvC,qBAAqB;IACrB,wBAAwB;IACxB,eAAe;IACf,OAAO;IACP,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,uCAAuC;IACvC,qBAAqB;IACrB,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,+CAA+C;AACnD;;AAEA;IACI,2CAA2C;IAC3C,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,gEAAgE;AAChE;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,cAAc;IACd,SAAS;IACT,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,8CAA8C;IAC9C,qBAAqB;AACzB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;IACd,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,SAAS;IACT,SAAS;IACT,UAAU;IACV,eAAe;AACnB;AACA;IACI,aAAa;IACb,MAAM;IACN,uCAAuC;IACvC,qBAAqB;IACrB,gCAAgC;IAChC,gBAAgB;AACpB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,wBAAwB;AAC5B;AACA;IACI,iCAAiC;AACrC;AACA;IACI,sCAAsC;IACtC,oBAAoB;AACxB;AACA;IACI,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,qCAAqC;IACrC,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,SAAS;IACT,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;AACrB;AACA;AACA;IACI,aAAa;IACb,WAAW;AACf;AACA;IACI,OAAO;IACP,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;;AAEA;IACI,aAAa;IACb,SAAS;AACb;AACA;;IAEI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".content-editor-shell {\n    --content-border: var(--color-border-soft);\n    display: grid;\n    gap: 1rem;\n    min-width: 0;\n    width: 100%;\n}\n\n/* The dashboard has broad aside/section rules. Keep the editor's nested layout isolated. */\ndiv.page .content-editor-shell aside.content-editor-sidebar {\n    align-items: stretch;\n    background: transparent;\n    display: grid;\n    height: auto;\n    margin: 0;\n    min-width: 0;\n    padding: 0;\n}\n\ndiv.page .content-editor-shell section.content-editor-main,\ndiv.page .content-editor-shell section.content-editor-panel {\n    background: var(--color-surface);\n    border: 1px solid var(--content-border);\n    border-radius: 0.4rem;\n    display: grid;\n    gap: 0.65rem;\n    margin: 0;\n    max-width: none;\n    padding: 1rem;\n    position: relative;\n}\n\ndiv.page .content-editor-shell section.content-editor-feature {\n    background: transparent;\n    border: 0;\n    margin: 0;\n    max-width: none;\n    padding: 0;\n    position: static;\n}\n\ndiv.page .content-editor-shell .content-editor-panel h2,\ndiv.page .content-editor-shell .content-editor-panel-header h2 {\n    border: 0;\n    font-size: 1.1rem;\n    margin: 0;\n    padding: 0;\n}\n\ndiv.page .content-editor-shell aside.content-editor-sidebar p {\n    font-size: 1rem;\n    padding: 0;\n    text-align: start;\n}\n\n.content-list-manager {\n    display: grid;\n    gap: 1rem;\n}\n\n.content-create-form,\n.content-link-tree-form {\n    align-items: end;\n    display: grid;\n    gap: 0.5rem;\n    grid-template-columns: minmax(12rem, 1fr) auto;\n}\n\n.content-create-form label {\n    grid-column: 1 / -1;\n}\n\n.content-create-form {\n    align-items: stretch;\n}\n\n.content-create-form > input,\n.content-create-form > button {\n    min-height: 3.25rem;\n}\n\n.content-list-table-wrap {\n    overflow-x: auto;\n}\n\n.content-list-table-wrap table {\n    width: 100%;\n}\n\n.content-list-table-wrap small {\n    display: block;\n}\n\n.content-list-actions,\n.content-list-pagination {\n    align-items: center;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n}\n\n.content-list-actions form {\n    margin: 0;\n}\n\n.content-list-pagination {\n    justify-content: space-between;\n    margin-top: 1rem;\n}\n\n.content-editor-topbar {\n    align-items: center;\n    background: var(--color-surface);\n    border: 1px solid var(--content-border);\n    display: flex;\n    gap: 1rem;\n    justify-content: space-between;\n    padding: 0.75rem;\n    position: sticky;\n    top: 0;\n    z-index: 20;\n}\n\n.content-editor-heading {\n    display: grid;\n    flex: 1;\n}\n\n.content-editor-heading > span,\n.content-editor-heading small {\n    color: var(--color-text);\n    font-size: 0.82rem;\n    opacity: 0.72;\n}\n\n.content-editor-topbar-actions,\n.content-editor-body-actions,\n.content-dialog-actions,\n.content-media-actions,\n.content-mode-tabs,\n.content-editor-toolbar {\n    align-items: center;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n}\n\n.content-editor-layout {\n    align-items: start;\n    display: grid;\n    gap: 1rem;\n    grid-template-columns: minmax(0, 2fr) minmax(18rem, 1fr);\n    min-width: 0;\n}\n\n.content-editor-main,\n.content-editor-panel {\n    background: var(--color-surface);\n    border: 1px solid var(--content-border);\n    border-radius: 0.4rem;\n    display: grid;\n    gap: 0.65rem;\n    padding: 1rem;\n}\n\n.content-editor-main,\n.content-editor-panel,\n.content-editor-sidebar,\n.content-editor-feature,\n.content-editor-feature > [role=\"tabpanel\"] {\n    min-width: 0;\n}\n\n.content-editor-shell input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"hidden\"]),\n.content-editor-shell select,\n.content-editor-shell textarea {\n    background: var(--color-surface);\n    border: 1px solid var(--color-border);\n    color: var(--color-text);\n    display: block;\n    font: inherit;\n    max-width: 100%;\n    padding: 0.55rem 0.65rem;\n    width: 100%;\n}\n\n.content-editor-sidebar {\n    display: grid;\n    gap: 1rem;\n}\n\n.content-editor-panel-header {\n    align-items: start;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n    justify-content: space-between;\n}\n\n.content-editor-panel h2,\n.content-editor-panel-header h2 {\n    margin: 0;\n}\n\n.content-mode-tabs {\n    border-bottom: 1px solid var(--content-border);\n    margin-top: 0.5rem;\n    padding-bottom: 0.5rem;\n}\n\n.content-editor-tool-button,\n.content-mode-tab {\n    appearance: none;\n    background: var(--color-surface);\n    border: 1px solid var(--content-border);\n    border-radius: 0.3rem;\n    color: var(--color-text);\n    cursor: pointer;\n    font: inherit;\n    font-size: 0.82rem;\n    font-weight: 600;\n    line-height: 1.2;\n    margin: 0;\n    min-height: 2rem;\n    padding: 0.4rem 0.65rem;\n    white-space: nowrap;\n}\n\n.content-editor-tool-button:hover,\n.content-mode-tab:hover {\n    background: var(--color-hover-bg);\n    border-color: var(--color-accent);\n}\n\n.content-editor-tool-button:focus-visible,\n.content-mode-tab:focus-visible {\n    outline: 2px solid var(--color-accent);\n    outline-offset: 2px;\n}\n\n.content-editor-tool-button[aria-pressed=\"true\"],\n.content-mode-tab[aria-selected=\"true\"] {\n    background: var(--color-accent);\n    border-color: var(--color-accent);\n    color: #fff;\n}\n\n.content-editor-tool-button:disabled,\n.content-mode-tab:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n\n.content-rich-text-editor,\n.content-source-editor {\n    border: 1px solid var(--content-border);\n    border-radius: 0.25rem;\n    min-height: 24rem;\n    overflow: hidden;\n}\n\n.content-editor-toolbar {\n    align-items: stretch;\n    background: var(--color-surface-soft);\n    border-bottom: 1px solid var(--content-border);\n    padding: 0.5rem;\n}\n\n.content-rich-text-editor-input {\n    min-height: 22rem;\n    outline: none;\n    padding: 1rem;\n}\n\n.content-rich-text-editor-input > * {\n    max-width: 100%;\n}\n\n.content-source-editor .cm-editor {\n    max-width: 100%;\n    min-height: 24rem;\n}\n\n.content-source-editor .cm-scroller {\n    overflow: auto;\n}\n\n.content-media-list {\n    display: grid;\n    gap: 0.5rem;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.content-media-list li {\n    align-items: center;\n    border: 1px solid var(--content-border);\n    display: grid;\n    gap: 0.5rem;\n    grid-template-columns: 4rem minmax(0, 1fr) auto;\n    padding: 0.5rem;\n    min-width: 0;\n}\n\n.content-media-list li > * {\n    min-width: 0;\n}\n\n.content-youtube-list li {\n    grid-template-columns: minmax(0, 1fr) auto;\n}\n\n.content-youtube-add {\n    display: grid;\n    gap: 0.5rem;\n}\n\n.content-media-list img {\n    height: 4rem;\n    object-fit: cover;\n    width: 4rem;\n}\n\n.content-media-list small,\n.content-media-list strong {\n    display: block;\n    overflow-wrap: anywhere;\n}\n\n.content-featured-grid {\n    display: grid;\n    gap: 0.75rem;\n    grid-template-columns: repeat(auto-fit, minmax(min(12rem, 100%), 1fr));\n}\n\n.content-featured-choice {\n    border: 1px solid var(--content-border);\n    display: grid;\n    gap: 0.5rem;\n    padding: 0.75rem;\n}\n\n.content-featured-choice h3 {\n    margin: 0;\n}\n\n.content-featured-choice img {\n    aspect-ratio: 16 / 9;\n    object-fit: cover;\n    width: 100%;\n}\n\n.content-masthead-preview {\n    aspect-ratio: 16 / 6;\n    object-fit: cover;\n    width: 100%;\n}\n\n.content-editor-content-section {\n    border-top: 1px solid var(--content-border);\n    display: grid;\n    gap: 0.75rem;\n    margin-top: 0.5rem;\n    padding-top: 1rem;\n}\n\n.content-editor-content-heading {\n    align-items: start;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n    justify-content: space-between;\n}\n\n.content-editor-content-heading h2,\n.content-editor-content-heading p {\n    margin: 0;\n}\n\n.content-segment-toggle {\n    display: flex;\n    gap: 0.35rem;\n}\n\n.content-segment-toggle button {\n    appearance: none;\n    background: var(--color-surface);\n    border: 1px solid var(--content-border);\n    border-radius: 999px;\n    color: var(--color-text);\n    cursor: pointer;\n    font: inherit;\n    font-size: 0.78rem;\n    font-weight: 700;\n    padding: 0.35rem 0.65rem;\n}\n\n.content-segment-toggle button[aria-selected=\"true\"] {\n    background: var(--color-accent);\n    border-color: var(--color-accent);\n    color: #fff;\n}\n\n.content-publication-details {\n    display: grid;\n    gap: 0.5rem;\n    margin: 0;\n}\n\n.content-publication-details div {\n    display: flex;\n    gap: 0.5rem;\n    justify-content: space-between;\n}\n\n.content-publication-details dt {\n    font-weight: 700;\n}\n\n.content-publication-details dd {\n    margin: 0;\n    overflow-wrap: anywhere;\n    text-align: end;\n}\n\n.content-comment-list {\n    display: grid;\n    gap: 0.75rem;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.content-comment-list > li {\n    border: 1px solid var(--content-border);\n    display: grid;\n    gap: 0.5rem;\n    padding: 0.75rem;\n}\n\n.content-comment-list header {\n    display: flex;\n    gap: 0.5rem;\n    justify-content: space-between;\n}\n\n.content-comment-reply {\n    display: grid;\n    gap: 0.5rem;\n}\n\n.content-inline-alt-dialog {\n    background: var(--color-surface);\n    border-radius: 0.5rem;\n    display: grid;\n    gap: 0.75rem;\n    margin: 8vh auto;\n    max-width: 34rem;\n    padding: 1.25rem;\n    width: calc(100% - 2rem);\n}\n\n.content-conversion-columns {\n    display: grid;\n    gap: 1rem;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.content-conversion-columns pre {\n    max-height: 24rem;\n    overflow: auto;\n    white-space: pre-wrap;\n}\n\n.content-preview-frame {\n    border: 1px solid var(--content-border);\n    height: min(72vh, 900px);\n    width: 100%;\n}\n\n.content-save-status.is-offline,\n.content-save-status.is-invalid,\n.content-save-status.is-conflict {\n    color: var(--color-danger-text, #9d1c1c);\n    font-weight: 700;\n}\n\n@media (max-width: 1150px) {\n    .content-editor-topbar,\n    .content-editor-layout {\n        align-items: stretch;\n        grid-template-columns: minmax(0, 1fr);\n    }\n\n    .content-editor-topbar {\n        display: grid;\n        position: static;\n    }\n\n    .content-conversion-columns {\n        grid-template-columns: minmax(0, 1fr);\n    }\n\n    .content-featured-grid {\n        grid-template-columns: minmax(0, 1fr);\n    }\n\n    .content-create-form,\n    .content-link-tree-form {\n        grid-template-columns: minmax(0, 1fr);\n    }\n\n    .content-media-list li {\n        grid-template-columns: 3rem minmax(0, 1fr);\n    }\n\n    .content-youtube-list li {\n        grid-template-columns: minmax(0, 1fr);\n    }\n\n    .content-media-actions {\n        grid-column: 1 / -1;\n    }\n\n}\n\n/* DisplaySettingsSection — design templates + page-takeover mode\n   (docs/REACT-PAGE-BLOG-EDITOR.md, 2026-08-21 entry). */\n.content-display-mode-toggle {\n    display: flex;\n    gap: 0.35rem;\n}\n\n.content-display-mode-option {\n    appearance: none;\n    background: var(--color-surface);\n    border: 1px solid var(--content-border);\n    border-radius: 0.3rem;\n    color: var(--color-text);\n    cursor: pointer;\n    flex: 1;\n    font: inherit;\n    font-size: 0.78rem;\n    font-weight: 600;\n    padding: 0.35rem 0.5rem;\n}\n\n.content-display-mode-option.selected {\n    background: var(--color-accent);\n    border-color: var(--color-accent);\n    color: #fff;\n}\n\n.content-display-template-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.35rem;\n}\n\n.content-display-template-card {\n    appearance: none;\n    background: var(--color-surface);\n    border: 1px solid var(--content-border);\n    border-radius: 0.3rem;\n    color: var(--color-text);\n    cursor: pointer;\n    font: inherit;\n    font-size: 0.76rem;\n    font-weight: 600;\n    padding: 0.4rem 0.55rem;\n    text-align: center;\n}\n\n.content-display-template-card.selected {\n    border-color: var(--color-accent);\n    box-shadow: 0 0 0 2px var(--color-accent) inset;\n}\n\n.content-editor-panel-sub {\n    border-top: 1px solid var(--content-border);\n    display: grid;\n    gap: 0.5rem;\n    margin-top: 0.5rem;\n    padding-top: 0.5rem;\n}\n\n.content-editor-panel-label {\n    font-weight: 600;\n}\n\n/* Keep writing prominent and disclose configuration below it. */\n.content-editor-shell, .content-list-manager {\n    max-width: 1100px;\n    margin-inline: auto;\n}\n.content-editor-layout {\n    grid-template-columns: minmax(0, 1fr);\n}\ndiv.page .content-list-manager > section {\n    display: block;\n    margin: 0;\n    max-width: none;\n}\n.content-list-manager input[type=\"text\"] {\n    box-sizing: border-box;\n    width: 100%;\n    min-width: 0;\n}\n.content-editor-main input, .content-editor-main select, .content-editor-main textarea {\n    box-sizing: border-box;\n}\n.content-writing-language {\n    display: flex;\n    align-items: end;\n    gap: 1.5rem;\n    padding-bottom: 1rem;\n    border-bottom: 1px solid var(--content-border);\n    margin-bottom: 0.5rem;\n}\n.content-writing-language > div {\n    flex: 0 0 220px;\n}\n.content-writing-language label {\n    display: block;\n    margin-bottom: 0.35rem;\n    font-size: 0.875rem;\n}\ndiv.page .content-editor-shell .content-writing-language p {\n    margin: 0;\n    padding: 0.4rem 0;\n    text-align: start;\n    font-size: 0.875rem;\n}\n.content-editor-main > label {\n    font-weight: 600;\n}\n.content-editor-main #content-title {\n    font-size: 1.25rem;\n}\n.content-editor-content-section {\n    border-top: 0;\n    margin-top: 0.75rem;\n    padding-top: 0;\n}\ndiv.page .content-editor-shell .content-editor-content-heading h2 {\n    border: 0;\n    margin: 0;\n    padding: 0;\n    font-size: 1rem;\n}\n.content-editor-settings {\n    display: grid;\n    gap: 0;\n    border: 1px solid var(--content-border);\n    border-radius: 0.4rem;\n    background: var(--color-surface);\n    overflow: hidden;\n}\n.content-settings-group + .content-settings-group {\n    border-top: 1px solid var(--content-border);\n}\n.content-settings-group > summary {\n    padding: 1rem 1.25rem;\n    font-weight: 600;\n    cursor: pointer;\n    color: var(--color-text);\n}\n.content-settings-group > summary:hover {\n    background: var(--color-hover-bg);\n}\n.content-settings-group > summary:focus-visible {\n    outline: 2px solid var(--color-accent);\n    outline-offset: -3px;\n}\ndiv.page .content-editor-shell .content-settings-group > section {\n    margin: 0 1.25rem 1rem;\n    max-width: none;\n}\n.content-settings-group > p, .content-settings-group > details {\n    margin: 1rem 1.25rem;\n}\n.content-language-note {\n    padding: 0.75rem;\n    background: var(--color-surface-soft);\n    border-radius: 0.25rem;\n    font-size: 0.875rem;\n}\n.content-translation-actions {\n    display: flex;\n    justify-content: end;\n}\n.content-text-action {\n    appearance: none;\n    background: transparent;\n    border: 0;\n    color: var(--color-link);\n    cursor: pointer;\n    font: inherit;\n    font-size: 0.875rem;\n    text-decoration: underline;\n    padding: 0.4rem 0;\n}\n@media (max-width: 650px) {\n.content-writing-language {\n    display: grid;\n    gap: 0.5rem;\n}\n.content-editor-topbar-actions > .button {\n    flex: 1;\n    text-align: center;\n    padding-inline: 0.75rem;\n}\n.content-editor-toolbar {\n    gap: 0.3rem;\n}\n.content-editor-tool-button {\n    min-height: 2.25rem;\n    padding: 0.4rem 0.55rem;\n}\n}\n\n.content-inline-alt-fields {\n    display: grid;\n    gap: 1rem;\n}\n.content-inline-alt-fields > input[type=\"text\"],\n.content-inline-alt-fields > input:not([type]) {\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.content-list-manager .content-editor-panel-header {\n    display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
